import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Invoices from "@/pages/Invoices";
import Inventory from "@/pages/Inventory";
import CRM from "@/pages/CRM";
import HR from "@/pages/HR";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Support from "@/pages/Support";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Team from "@/pages/Team";
import Billing from "@/pages/Billing";
import BillingSuccess from "@/pages/BillingSuccess";
import AcceptInvite from "@/pages/AcceptInvite";
import Landing from "@/pages/Landing";
import { useLocation } from "react-router-dom";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground">
      <div className="animate-pulse font-mono text-sm">Chargement…</div>
    </div>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RootShell() {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <Loading />;
  if (!user) {
    return location.pathname === "/" ? <Landing /> : <Navigate to="/login" replace />;
  }
  if (user.company && !user.company.entitled) return <Navigate to="/billing" replace />;
  return <Layout />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" theme="dark" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
            <Route path="/billing/success" element={<ProtectedRoute><BillingSuccess /></ProtectedRoute>} />
            <Route
              path="/"
              element={<RootShell />}
            >
              <Route index element={<Dashboard />} />
              <Route path="facturation" element={<Invoices />} />
              <Route path="inventaire" element={<Inventory />} />
              <Route path="crm" element={<CRM />} />
              <Route path="rh" element={<HR />} />
              <Route path="rapports" element={<Reports />} />
              <Route path="equipe" element={<Team />} />
              <Route path="parametres" element={<Settings />} />
              <Route path="support" element={<Support />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
